import * as React from "react";
import { createTheme, styled } from "@mui/system";
import MUIToolbar, { ToolbarProps } from "@mui/material/Toolbar";

declare module "@mui/material/Toolbar" {
  interface ToolbarPropsVariantOverrides {
    size: string;
  }
}

export const Toolbar = styled(
  (props: ToolbarProps) => <MUIToolbar {...props} />,
  {
    name: "Toolbar",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({
  "&.MuiToolbar-root": {
    height: 48,
    background: theme.palette.primary.background,
    justifyContent: "space-between",
    paddingLeft: 16,
    paddingRight: 16,
  },
  "&.MuiToolbar-root .MuiIconButton-root": {
    color: theme.palette.primary.iconInverse,
    ":hover": {
      background: theme.palette.primary.primary80Color,
      minHeight: 48,
      height: 48,
    },
  },
}));
